package com.wintermar.inspection.core.ui.component.modal

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ModalLoading(
    showLoading: Boolean = false,
) {
    AnimatedVisibility(visible = showLoading, enter = fadeIn(), exit = fadeOut()) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CircularProgressIndicator(
                color = LocalAppTheme.current.color.icon.brand,
                modifier = Modifier.size(LocalAppTheme.current.dimension.size.icon.s),
            )
        }
    }
}
